export const SetExchange = (item) => ({
  type: "SET_EXCHANGE",
  payload: item,
});
export const TickerName = (item) => ({
  type: "TICKER_NAME",
  payload: item,
});
export const SetPage = (item) => ({
  type: "SET_PAGE",
  payload: item,
});
export const RowsPerPageOptions = (item) => ({
  type: "ROWS_PER_PAGE",
  payload: item,
});
export const TickerDetails = (item) => ({
  type: "TICKER_DETAILS",
  payload: item,
});
export const RsClassic = (item) => ({
  type: "RSLEVEL_CLASSIC",
  payload: item,
});
export const RsFibo = (item) => ({
  type: "RSLEVEL_FIBO",
  payload: item,
});
export const Returns = (item) => ({
  type: "SET_RETURNS",
  payload: item,
});
export const ActiveButton = (item) => ({
  type: "ACTIVE_BUTTON",
  payload: item,
});
export const SelectedDropdownOption = (item) => ({
  type: "SELECTED_DROPDOWN_OPTION",
  payload: item,
});
export const SetError = (item) => ({
  type: "SET_ERROR",
  payload: item,
});
export const VolumeAnalysis = (item) => ({
  type: "SET_VOLUME_ANALYSIS",
  payload: item,
});

export const SearchItems = (item) => ({
  type: "SEARCH_ITEM",
  payload: item,
});
export const isLoading = (item) => ({
  type: "IS_LOADING",
  payload: item,
});
export const setJsonData = (data) => ({
  type: "JSONDATA",
  payload: data,
});
export const setJsonRsl = (data) => ({
  type: "JSONRSL",
  payload: data,
});
export const setJsonReturn = (data) => ({
  type: "JSONRTN",
  payload: data,
});
export const setJsonVol = (data) => ({
  type: "JSONVOL",
  payload: data,
});
export const ShowAppBar = (show) => ({
  type: "SHOWAPPBAR",
  payload: show,
});
export const SearchValue = (item) => ({
  type: "SEARCH_VALUE",
  payload: item,
});
export const isAuthenticated = (item) => ({
  type: "SET_ISAUTHENTICATED",
  payload: item,
});
export const checked = (item) => ({
  type: "SET_CHECKED",
  payload: item,
});
export const authToken = (item) => ({
  type: "SET_AUTHTOKEN",
  payload: item,
});
export const selectedAnalytics = (item) => ({
  type: "SELECTED_ANALYTICS",
  payload: item,
});
export const sample = (item) => ({
  type: "CHECK_SAMPLE",
  payload: item,
});
export const meanReversion = (item) => ({
  type: "MEAN_REVERSION",
  payload: item,
});
export const setKeymetrics = (item) => ({
  type: "KEY_METRICS",
  payload: item,
});
